<template>
  <section id="founder">
    <div class="container">
      <div class="image">
        <img src="~assets/images/retta.jpg">
        <h5>Founder &amp; CEO</h5>
        <p>Retta Jitner<br>
          Pencils for Kids, Inc.</p>
      </div>
      <div class="content">
        <h2>Meet Our Founder</h2>
        <div v-html="bio"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'founder',
  props: ['bio']
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

section {
  padding: 4rem 0;
  background-color: white;
}

.container {
  @include media('tablet') {
    display: flex;
    align-items: center;
  }
  @include media('desktop') {
    width: 900px;
  }
}

.image {
  background-color: $gold;
  display: inline-block;
  margin-bottom: 2rem;
  color: black;
  @include media('tablet') {
    display: block;
    margin-bottom: 0;
    margin-right: 5rem;
  }
  h5 {
    font-size: 0.8rem;
    text-transform: uppercase;
    margin: 1rem 1.5rem 0.2rem;
  }
  p {
    font-size: 0.8rem;
    margin: 0 1.5rem 1rem;
  }
}

.content {
  h2 {
    color: $brand-primary;
    margin-bottom: 2.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// Founder.vue?9f15f5c8